"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenticExtractionResultSchema = exports.ExtractorEventKind = exports.AgenticExtractionRunStatus = exports.AGENTIC_EXTRACTION_RESULT_SCHEMA_VERSION = void 0;
exports.parseAgenticExtractionResult = parseAgenticExtractionResult;
const z = require("zod");
const agentic_extractor_registry_1 = require("./agentic-extractor-registry");
exports.AGENTIC_EXTRACTION_RESULT_SCHEMA_VERSION = 1;
var AgenticExtractionRunStatus;
(function (AgenticExtractionRunStatus) {
    AgenticExtractionRunStatus["Emitted"] = "emitted";
    AgenticExtractionRunStatus["Withheld"] = "withheld";
})(AgenticExtractionRunStatus || (exports.AgenticExtractionRunStatus = AgenticExtractionRunStatus = {}));
var ExtractorEventKind;
(function (ExtractorEventKind) {
    ExtractorEventKind["Started"] = "started";
    ExtractorEventKind["Completed"] = "completed";
    ExtractorEventKind["Failed"] = "failed";
})(ExtractorEventKind || (exports.ExtractorEventKind = ExtractorEventKind = {}));
exports.AgenticExtractionResultSchema = z.object({
    schemaVersion: z.number(),
    packageId: z.string(),
    extractorName: z.nativeEnum(agentic_extractor_registry_1.AgenticExtractorName),
    extractorVersion: z.number().int().min(1),
    createdAt: z.number(),
    sigmaModelType: z.string(),
    resolution: z.unknown().optional(),
});
function parseAgenticExtractionResult(blob) {
    const parsed = exports.AgenticExtractionResultSchema.parse(blob);
    if (parsed.schemaVersion !== exports.AGENTIC_EXTRACTION_RESULT_SCHEMA_VERSION) {
        throw new Error(`Unsupported agentic extraction result schemaVersion: ${parsed.schemaVersion}`);
    }
    return parsed;
}
//# sourceMappingURL=agentic-extraction-result.js.map